import { CountryCodeEnum } from '@/components/SelectUserCountry/types';

export const countryNameByCountryCode: Record<CountryCodeEnum, string> = {
  [CountryCodeEnum.USA]: 'USA',
  [CountryCodeEnum.Ecuador]: 'Ecuador',
  [CountryCodeEnum.Peru]: 'Peru',
  [CountryCodeEnum.Chile]: 'Chile',
  [CountryCodeEnum.Brazil]: 'Brazil',
  [CountryCodeEnum.Ukraine]: 'Ukraine',
};
